let scrollers = false;
jQuery(document).ready(function(){
    scrollers = jQuery('.wp-block-vif-scrollers');
    if(!scrollers.length) return;

    jQuery(window).resize(checkScrollerPosition);
    checkScrollerPosition();

    jQuery(window).scroll(checkScollerDisplayed);
    checkScollerDisplayed();
});

function checkScrollerPosition(){
    scrollers.each(function(){
        let currentScrollers = jQuery(this);
        currentScrollers.get(0).style.setProperty("--header", Math.floor(jQuery('header').outerHeight(true))+'px');
    })
}
function checkScollerDisplayed(){
    let scrollTopPos = jQuery(window).scrollTop();
    let halfScreen = Math.floor(jQuery(window).height()/2);
    scrollers.each(function(){
        let currentScrollers = jQuery(this);
        currentScrollers.find('>.wp-block-vif-scroller').each(function(){
            let currentScroller = jQuery(this);
            let currentPosition = currentScroller.offset().top;
            let currentHeight = currentScroller.outerHeight(true);
            if(scrollTopPos + halfScreen + 55 > currentPosition && scrollTopPos + halfScreen - 55 < currentPosition + currentHeight - 55) currentScroller.addClass('active');
            else currentScroller.removeClass('active');
        })
    })
}